import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import AlertDialog from "../AlertDialog";
import ReCAPTCHA from "react-google-recaptcha";
import { CAPTCHA_KEY } from "../../constants/general";
import { adviceAlert, waitingAndSuccessAlert } from "../../utils/alerts";
import { sendComments } from "../../store/actions/comments";
import { COMMENT_TYPE_1, COMMENT_TYPES } from "../../constants/comments";
import InputArea from "../UI/Inputs/InputArea";
import InputText from "../UI/Inputs/InputText";
import { ButtonBase, Card, Typography } from "@mui/material";

const FormComments = ({ onClose }) => {
  const { t } = useTranslation();
  const [comment, setComment] = useState(null);
  const [email, setEmail] = useState(null);
  const [type, setType] = useState(COMMENT_TYPE_1);
  const [captchaValidated, setCaptchaValidated] = useState(null);
  const captchaRef = useRef(null);

  const saveHandler = () => {
    if (!captchaValidated) {
      adviceAlert({ t: t, text: t("errors.captchaRequried") });
    } else {
      waitingAndSuccessAlert({
        t: t,
        title: t("comments.sending"),
        waitingFunction: () =>
          sendComments({
            email: email,
            message: comment,
            type: type,
            "g-recapthca-response": captchaValidated,
          }),
        successMessage: t("comments.sendingSuccess"),
        onSuccess: onClose,
        ignoreResult: true,
        onError: (e) => {
          if (captchaRef.current) {
            setCaptchaValidated(null);
            captchaRef.current.reset();
          }
        },
      });
    }
  };

  const onChangeCaptchaHandler = (value) => {
    setCaptchaValidated(value);
  };

  return (
    <AlertDialog
      transition
      show
      onClose={onClose}
      title={t("comments.title")}
      acceptTitle={t("actions.send")}
      closeTitle={t("actions.cancel")}
      blockClose
      maxWidth="md"
      contentClassName="pt-1"
      onAccept={saveHandler}
      fullScreenMobile
      acceptDisabled={!comment}
    >
      <div className="row">
        <div className="col-md-6">
          <Typography>{t("comments.typeIntro")}</Typography>
          {COMMENT_TYPES.map((a) => (
            <CommentType type={a} key={a.value} typeSelected={type} onClick={setType} />
          ))}
        </div>
        <div className="col-md-6 d-flex flex-column">
          <Typography>{t(COMMENT_TYPES.find((c) => c.value === type).title)}</Typography>
          <InputArea label={t("comments.comment")} value={comment} onChange={setComment} required />
          <InputText
            label={t("comments.email")}
            placeholder={t("comments.emailPlaceholder")}
            value={email}
            onChange={setEmail}
          />
          <div className="mt-3 d-flex justify-content-end">
            <ReCAPTCHA sitekey={CAPTCHA_KEY} onChange={onChangeCaptchaHandler} ref={captchaRef} />
          </div>
        </div>
      </div>
    </AlertDialog>
  );
};

export default FormComments;

const CommentType = ({ type, typeSelected, onClick }) => {
  const { t } = useTranslation();
  const clickHandler = () => {
    onClick(type.value);
  };
  return (
    <Card className="mt-2">
      <ButtonBase
        className="pt-3 pb-3 pl-2 pr-2 d-flex align-items-center justify-content-start w-100"
        sx={{
          backgroundColor: typeSelected === type.value ? "#3f51b5" : "#cfd8dc",
          color: typeSelected === type.value ? "#fff" : "inherit",
        }}
        onClick={clickHandler}
      >
        {type.icon}
        <Typography className="ml-2" variant="button" sx={{ color: typeSelected === type.value ? "#fff" : "inherit" }}>
          {t(type.text)}
        </Typography>
      </ButtonBase>
    </Card>
  );
};
